/**
 * @generated SignedSource<<a4851b121ee371b8bae5bde4bfb9dfbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationSoftOneCreateScreenOrgMutation$variables = {
  accountIds: ReadonlyArray<string>;
};
export type IntegrationSoftOneCreateScreenOrgMutation$data = {
  readonly store: {
    readonly activateIntegrationSoftOneOrg: {
      readonly id: string;
    } | null;
  };
};
export type IntegrationSoftOneCreateScreenOrgMutation = {
  response: IntegrationSoftOneCreateScreenOrgMutation$data;
  variables: IntegrationSoftOneCreateScreenOrgMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
          }
        ],
        "concreteType": "IntegrationSoftOne",
        "kind": "LinkedField",
        "name": "activateIntegrationSoftOneOrg",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationSoftOneCreateScreenOrgMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationSoftOneCreateScreenOrgMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "900c8a5cc7147fc0667d383d1402fa5a",
    "id": null,
    "metadata": {},
    "name": "IntegrationSoftOneCreateScreenOrgMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationSoftOneCreateScreenOrgMutation(\n  $accountIds: [ID!]!\n) {\n  store {\n    activateIntegrationSoftOneOrg(accountIds: $accountIds) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "00f4350d6897b7c34b722a99d5932739";

export default node;
